import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import FormField from '../form-field';
import { formatMessage } from '../../lib/intl';
import iconEmailActive from '../../img/icon-email-active.svg';
import iconTelephoneInactive from '../../img/icon-telephone-inactive.svg';

const i18n = defineMessages({
  viaEmail: {
    id: 'invitePeople.inviteFields.viaEmail',
    defaultMessage: 'Via E-mail',
  },
  viaSMS: {
    id: 'invitePeople.inviteFields.viaSMS',
    defaultMessage: 'Via SMS',
  },
  optional: {
    id: 'invitePeople.inviteFields.optional',
    defaultMessage: 'optional',
  },
  messageFieldSubtext: {
    id: 'invitePeople.inviteFields.messageField.subtext',
    defaultMessage: 'Invitations that include a personal message are 42% more successful',
  },
});

export class InviteFields extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  state = {
    subjectCharsLeft: 300,
    showImportOptions: false,
  };

  onSubjectChange = (event) => {
    const value = event.target.value;
    const limit = 300;
    this.setState({ subjectCharsLeft: limit - value.length });
    this.props.onSubjectChange(value);
  }

  onMessageChange = (event) => {
    const value = event.target.value;
    this.props.onMessageChange(value);
  }

  render() {
    return (
      <div className="invite-fields">
        <div className="row msg-types">
          <div className="col-12">
            <button
              type="button"
              className="btn msg-type email active"
              data-toggle="button"
              disabled
              checked
            >
              <img src={iconEmailActive} alt={this.formatMessage(i18n.viaEmail)} />
              {' ' + this.formatMessage(i18n.viaEmail)}
            </button>
            <button
              type="button"
              className="btn msg-type sms"
              data-toggle="button"
              disabled
            >
              <img src={iconTelephoneInactive} alt={this.formatMessage(i18n.viaSMS)} />
              {' ' + this.formatMessage(i18n.viaSMS)}
            </button>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 contacts-field-container">
            <Field
              noGroup
              type="emails"
              name="emails"
              component={FormField}
              onInvalid={this.props.onEmailsInvalid}
              label={
                <FormattedMessage
                  id="invites-form.fields.emails"
                  defaultMessage="Email(s)*"
                />
              }
            />

          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Field
              name="subject"
              type="text"
              insideHint={this.state.subjectCharsLeft}
              onChange={this.onSubjectChange}
              maxLength="300"
              label={
                <FormattedMessage
                  id="invitePeople.inviteFields.textField.label"
                  defaultMessage="Subject {optional}"
                  values={{
                    optional: (
                      <span className="cool-grey ml-1 text-normal">
                        {this.formatMessage(i18n.optional)}
                      </span>
                    ),
                  }}
                />
              }
              className="subject"
              component={FormField}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Field
              name="message"
              type="textarea"
              label={
                <FormattedMessage
                  id="invitePeople.inviteFields.message.label"
                  defaultMessage="Message {optional}"
                  values={{
                    optional: (
                      <span className="cool-grey ml-1 text-normal">
                        {this.formatMessage(i18n.optional)}
                      </span>
                    ),
                  }}
                />
              }
              subtext={this.formatMessage(i18n.messageFieldSubtext)}
              className="message"
              onChange={this.onMessageChange}
              component={FormField}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(InviteFields);



// WEBPACK FOOTER //
// ./src/desktop/components/invite-people/invite-fields.js